module.exports = {"embedded":"false","defaultView":"Site Plan"}